<template>
    <div class="group">
        <input @input="$emit('input', $event.target.value)" :value=value :type=type >
        <label>{{label}}</label>
    </div>
</template>

<script>
    export default {
        name: "modal_input",
        props: ['type', 'label', 'value'],

    }
</script>

<style lang="scss" scoped>
    @import "../assets/colors.scss";
    .group {
        position: relative;
        margin-bottom: 1.2em;
    }
    input {
        font-size: 1em;
        padding-top: 0.5em;
        display: block;
        width: 90%;
        border: none;
        border-bottom: 1px solid #757575;
        margin: auto;
    }
    input:focus {
        outline: none;
    }

    label {
        color: #999;
        font-size: 1em;
        position: absolute;
        pointer-events: none;
        left: 35px;
        top: 10px;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    /* active state */
    input:focus ~ label, input:valid ~ label {
        top: -10px;
        font-size: 0.7em;
        color: $company-primary;
    }
</style>